export default __webpack_public_path__ + "24d2ced4a922c7fb47f13a760d335d1e.svg";